import script from "./CartDeliveryLocations.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartDeliveryLocations.vue?vue&type=script&setup=true&lang=ts"

import "./CartDeliveryLocations.vue?vue&type=style&index=0&id=1fa5e7a2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa5e7a2"]])

export default __exports__